/* Labels e formatadores compartilhados (pt-BR) das telas de admin. */

// EP8 BATTLESTYLE enum (1-indexed):
//   1=Warrior, 2=Blader, 3=Wizard, 4=Force Archer, 5=Force Shielder, 6=Force Blader
// EP33+ acrescenta:
//   7=Gladiator, 8=Force Gunner, 9=Dark Mage
//
// Suportamos 0-indexed também (caso o backend devolva sem o +1).
export const CLASSES_PT: Record<number, string> = {
  // 1-indexed (Cabal-BR oficial)
  1: 'Guerreiro',
  2: 'Duelista',
  3: 'Mago',
  4: 'Arqueiro Arcano',
  5: 'Guardião Arcano',
  6: 'Espadachim Arcano',
  7: 'Gladiador',
  8: 'Atirador Arcano',
  9: 'Mago Negro',
  0: 'Guerreiro',
};

// Nome curto unico pra cards/charts onde precisa abreviar.
// NUNCA usar label.split(' ')[0] — gera colisao (Mago/MagoNegro, Espadachim Arc/Duelista).
export const CLASSES_PT_SHORT: Record<number, string> = {
  1: 'Guerreiro',
  2: 'Duelista',
  3: 'Mago',
  4: 'Arqueiro',
  5: 'Guardião',
  6: 'Esp.Arcano',
  7: 'Gladiador',
  8: 'Atirador',
  9: 'M.Negro',
  0: 'Guerreiro',
};

export const formatClassShort = (id: number | null | undefined) =>
  id != null ? CLASSES_PT_SHORT[id] || `Cl${id}` : '—';

// Nation 1 = Capella, Nation 2 = Procyon (confirmado pelo servidor do jogo), Nation 3 = GM.
// Cores oficiais Liberty: Capella #ca69d3 (asset 1.png), Procyon #2a7ddd (asset 2.png).
export const NATIONS_PT: Record<number, { name: string; classes: string }> = {
  1: { name: 'Capella', classes: 'text-fuchsia-400 border-fuchsia-500/30 bg-fuchsia-500/10' },
  2: { name: 'Procyon', classes: 'text-blue-400 border-blue-500/30 bg-blue-500/10' },
  3: { name: 'GM', classes: 'text-amber-400 border-amber-500/30 bg-amber-500/10' },
};

export const NATION_COLORS: Record<number, string> = {
  1: '#ca69d3',  // Capella (rosa/lilás oficial Liberty)
  2: '#2a7ddd',  // Procyon (azul oficial Liberty)
  3: '#f59e0b',  // GM
};

export const formatClass = (id: number | null | undefined) =>
  id != null ? CLASSES_PT[id] || `Classe ${id}` : '—';

// cabal_character_table.PlayTime é acumulado em MINUTOS pelo servidor
// (WorldSvr soma delta = ticks/(60*1000) a cada UpdateUserPlayTimePeriod minutos).
// Não são segundos. Bate com o formatPlayTime do painel do jogador (AccountPage).
export const formatPlaytime = (min: number | null | undefined) => {
  if (!min || min < 1) return '—';
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};
